import { useTranslation } from "react-i18next";
import { Onfido } from "onfido-sdk-ui";
import { useEffect, useState } from "react";
import Layout from "./common/Layout";
import Back from "./common/Back";
import { useApi, useAppDispatch } from "../store/hooks";
import { sleep } from "../utils/utils";
import Loader from "./common/Loader";
import { GoToTheNextStep } from "./Step";
import { useNavigate } from "react-router-dom";

const IdCheck = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getWorkflow } = useApi();
  const [isLoading, setIsLoading] = useState(true);
  const [isOnfidoCompleted, setIsOnfidoCompleted] = useState(false);
  const [isOnfidoLoaded, setIsOnfidoLoaded] = useState(false);
  const [onfidoFailed, setOnfidoFailed] = useState(false);
  const { idCheckStart, idCheckCallback } = useApi();

  useEffect(() => {
    loadOnfido();
  }, []);

  const loadOnfido = async () => {
    setOnfidoFailed(false);
    try {
      setIsLoading(true);
      const data = await idCheckStart();
      const { sdkToken, runId } = data;
      Onfido.init({
        language: {
          locale: i18n.language,
        },
        token: sdkToken,
        containerId: "onfido-mount",
        workflowRunId: runId,
        onComplete: function (data) {
          fetchCallbackWithRetry();
        },
      });
      window.addEventListener("userAnalyticsEvent", (event) => {
        setIsOnfidoLoaded(true);
        setIsLoading(false);
      });
    } catch (err) {
      setIsLoading(false);
      setOnfidoFailed(true);
      console.error("Error loading Onfido SDK:", err);
    }
  };

  const fetchCallbackWithRetry = async () => {
    setIsOnfidoCompleted(true);
    let status;
    let retryCount = 0;
    try {
      while (status !== "Succeeded" && retryCount < 60) {
        await sleep(5000);
        const resp = await idCheckCallback();
        status = resp?.result ?? resp?.status;
        retryCount += 1;
      }
    } catch (err) {
      navigate("/Failure");
      return;
    }

    if (status === "Failed") {
      setIsOnfidoCompleted(false);
      setIsOnfidoLoaded(false);
      setIsLoading(false);
    } else if (status === "Succeeded") {
      GoToTheNextStep(navigate, dispatch, getWorkflow);
    } else {
      navigate("/Failure");
    }
  };

  return (
    <Layout>
      <div className="az-title">{t("idCheck.title")}</div>

      <Loader
        loading={isLoading || isOnfidoCompleted}
        title={t("initial.loader.title")}
        message={t("idCheck.onfido.loading.message")}
      />

      {!isOnfidoCompleted && (
        <>
          {!onfidoFailed ? (
            <div className={`${isOnfidoLoaded ? "row az-center" : "d-none"}`}>
              <div
                id="onfido-mount"
                className={`${isOnfidoLoaded ? "onfido-center mb-4" : "d-none"}`}
              />
            </div>
          ) : (
            <div className="id-check-failure-container">
              <div className="result-header">
                <div className="mb-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/error-cross.svg"}
                    alt="Error Cross Icon"
                    className="result-icon"
                  />
                </div>
              </div>
              <span className="text-danger mb-4">
                {t("idCheck.onfido.failed.message")}
                <br />
                {t("idCheck.onfido.failed.subMessage")}
              </span>
              <span>
                <img
                  src={process.env.PUBLIC_URL + "/images/reload.svg"}
                  alt="Error Cross Icon"
                />
                <button className="btn btn-link" onClick={loadOnfido}>
                  {t("global.retry")}
                </button>
              </span>
            </div>
          )}
        </>
      )}

      <Back message={t("back.label")} />
    </Layout>
  );
};

export default IdCheck;
